import type { OptionsVisibility } from '@atlassian/ui-modifications-core/types';

/**
 * Applies the visibility rule on provided list of entities
 *
 * @param optionsVisibility - object with a list of option ids and the `isVisible` rule
 * @param lookupValues - list of entities that will be filtered based on the visibility rule
 * @param optionKey - property name of the entity from the lookupValues list with which value will be compared
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const applyOptionsVisibilityRule = <T extends { [key: string]: any }>(
	{ options, isVisible }: OptionsVisibility,
	lookupValues: T[] = [],
	optionKey: string,
): T[] =>
	isVisible
		? lookupValues.filter((value) => options.includes(value[optionKey]))
		: lookupValues.filter((value) => !options.includes(value[optionKey]));
